/**
 * Шаблон строк при выборе запроса (перенос templateArticles_ / loadImportTemplate_ из 3.13.2):
 * какие OEM подставляются и что в них заполняется заранее.
 */
import { lineKey } from '../engine/engine.js';
import { findRequest } from '../engine/snapshot.js';
import { WAREHOUSE_ATTRS } from '../engine/types.js';
import { REQ_ALL } from './columns.js';
import { selectedRequestKey } from './validate.js';
/** Запросы для выбора в режиме: для закупки и наличия — открытые; для упаковки — с закупленным и не упакованным. */
export function selectableRequests(snap, mode) {
    const list = mode === 'packing'
        ? snap.reqs.filter((r) => r.status !== 'Отменено' && r.packable)
        : snap.reqs.filter((r) => r.status !== 'Выполнен' && r.status !== 'Отменено');
    // Новые сверху
    return list.slice().reverse();
}
export function templateArticles(header, snap) {
    const mode = header.mode;
    const reqKey = selectedRequestKey(header);
    const packing = mode === 'packing';
    if (reqKey) {
        const items = snap.reqItems[reqKey] ?? [];
        return items.filter((art) => {
            const line = snap.lines[lineKey(reqKey, art)];
            const a = snap.arts[art];
            if (!line || !a)
                return false;
            if (packing)
                return line.bought > 0 && a.packable > 0;
            return mode === 'stock' ? true : line.toBuy > 0;
        });
    }
    return Object.keys(snap.arts)
        .sort()
        .filter((art) => {
        const a = snap.arts[art];
        if (packing)
            return a.bought > 0 && a.packable > 0;
        return a.demand > 0 && a.toBuy > 0;
    });
}
/** Строки шаблона с подставленными значениями (HS code, цена и OEM от закупки, данные груза). */
export function buildTemplate(header, snap) {
    if (!String(header.reqSel).trim())
        return { rows: [], reason: 'noselect' };
    const reqKey = selectedRequestKey(header);
    if (reqKey && !findRequest(snap, reqKey))
        return { rows: [], reason: 'notfound' };
    const arts = templateArticles(header, snap);
    const rows = arts.map((art) => {
        const info = snap.arts[art];
        const row = { art };
        if (info.hs)
            row.hs = info.hs;
        if (header.mode === 'purchase') {
            // Последнее известное наличие и цена подтягиваются — остаётся указать «Закупить» или обновить их
            if (info.stockLeft !== null)
                row.stock = String(info.stockLeft);
            if (info.factoryPrice !== null)
                row.price = String(info.factoryPrice);
            if (info.suggestion)
                row.suggestion = info.suggestion;
        }
        if (header.mode === 'packing') {
            for (const key of WAREHOUSE_ATTRS) {
                const v = info.wattrs[key];
                if (v && !(key === 'hs' && row.hs))
                    row[key] = v;
            }
        }
        return row;
    });
    return { rows, reason: rows.length ? 'ok' : 'empty' };
}
export function templateReasonText(mode, reason, count) {
    if (reason === 'ok')
        return `Загружено строк: ${count}`;
    if (reason === 'noselect')
        return 'Сначала выберите № запроса.';
    if (reason === 'notfound')
        return 'Выбранный запрос не найден.';
    if (mode === 'packing') {
        return 'Нет позиций к упаковке: закупленное уже упаковано или ещё ничего не закуплено.';
    }
    return 'Нет позиций: всё уже закуплено.';
}
export function isAllRequests(reqSel) {
    return reqSel === REQ_ALL;
}
//# sourceMappingURL=template.js.map